import { defineEvent } from '../types/event';
export var REVIEW_WIDGET_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_Reviews_Widget'
        }
    ]
});
